<template>
  <div class="spt">
    <div>
      <div class="spt-header">
        <h2>SIM PHONG THUỶ</h2>
        <div class="w-100 header cat" v-if="vw>992">
          <div class="bg"></div>
          <div class="hcontent">
            <h3>Nhập thông tin để <br>chọn SIM hợp tuổi</h3>
            <div class="form">
              <div class="row pt-4">
                <div class="col-lg-3 col-md-12 text">
                  Ngày sinh (<font color="red">*</font>)
                </div>
                <div class="col-4 col-lg-3">
                  <v-select :clearable="false" v-model="day" :options="range(1,32)"/>
                </div>
                <div class="col-4 pl-0 col-lg-3">
                  <v-select :clearable="false" v-model="month" :options="range(1,13)"/>
                </div>
                <div class="col-4 pl-0 col-lg-3">
                  <v-select :clearable="false" v-model="year" :options="range(1923,2031)"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-sm-4 text">
                  Giờ sinh (<font color="red">*</font>)
                </div>
                <div class="col-lg-9 col-sm-12">
                  <v-select v-model="hour" :options="hours"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-4 text">
                  Giới tính (<font color="red">*</font>)
                </div>
                <div class="col-lg-2 col-4 text-left">
                  <b-form-radio name="gender" value="1" v-model="gender" class="mt-lg-2">Nam</b-form-radio>
                </div>
                <div class="col-lg-2 col-4 text-left">
                  <b-form-radio name="gender" value="2" v-model="gender" class="mt-lg-2">Nữ</b-form-radio>
                </div>
              </div>
              <button class="btn btn-primary btntuoi" @click="chonsim(0)">CHỌN SIM HỢP TUỔI</button>
              <h4>Chấm điểm phong thuỷ số điện thoại</h4>
              <img role="button" @click="$router.push({ name: 'diem-phong-thuy'})"
                   src="@/assets/images/simphongthuy/btn2.png" width="415"/>
            </div>
          </div>
        </div>
        <div class="w-100 header1" v-if="vw<=992">
          <div class="bg"></div>
          <div class="hcontent">
            <h3>Nhập thông tin để <br>chọn SIM hợp tuổi</h3>
            <div class="form">
              <div class="row pt-4">
                <div class="col-lg-3 col-md-12 text">
                  Ngày sinh (<font color="red">*</font>)
                </div>
                <div class="col-4 col-lg-3">
                  <v-select :clearable="false" v-model="day" :options="range(1,32)"></v-select>
                </div>
                <div class="col-4 pl-0 col-lg-3">
                  <v-select :clearable="false" v-model="month" :options="range(1,13)"/>
                </div>
                <div class="col-4 pl-0 col-lg-3">
                  <v-select :clearable="false" v-model="year" :options="range(1923,2031)"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-sm-4 text">
                  Giờ sinh (<font color="red">*</font>)
                </div>
                <div class="col-lg-9 col-sm-12">
                  <v-select v-model="hour" :options="hours"/>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-lg-3 col-4 text">
                  Giới tính (<font color="red">*</font>)
                </div>
                <div class="col-lg-2 col-4 text-left">
                  <b-form-radio name="gender" value="1" v-model="gender" class="mt-lg-2">Nam</b-form-radio>
                </div>
                <div class="col-lg-2 col-4 text-left">
                  <b-form-radio name="gender" value="2" v-model="gender" class="mt-lg-2">Nữ</b-form-radio>
                </div>
              </div>
              <button class="btn btn-primary btntuoi mt-3" @click="chonsim(0)">CHỌN SIM HỢP TUỔI</button>
            </div>
          </div>
        </div>
        <div class="card mt-2">
          <div class="car-body">
            <h4>Chấm điểm phong thuỷ số điện thoại</h4>
            <img role="button" @click="$router.push({ name: 'diem-phong-thuy'})"
                 src="@/assets/images/simphongthuy/btn2.png" width="415"/>
          </div>
        </div>
      </div>
      <div class="spt-content">
        <div class="cheader mb-4" ref="sim_list">
          <img src="@/assets/images/simphongthuy/stick.png"/>
          <h2>Danh mục SIM PHONG THỦY</h2>
          <img src="@/assets/images/simphongthuy/stick.png"/>
        </div>
        <div class="text-center">
          <div role="button" @click="chonsim(i.id)" class="loc" v-for="i in sim_types" :key="i.id">{{ i.text }}</div>
        </div>
        <div class="text-center">
          <div role="button" class="loc" @click="chonsim(i.id,'menh')" v-for="i in menhs" :key="i.id">{{ i.text }}</div>
        </div>
      </div>
      <div class="spt-content pt-4 pb-0 mt-1 mb-0" v-if="(decryptedQuery.type!=0 && decryptedQuery.menh!=1)">
        <div class="cheader1">
          {{ sim_types.find(i => i.id == decryptedQuery.type).text }}
        </div>
        <div class="ccontent1">
          <p v-html="sim_types.find(i=>i.id==decryptedQuery.type).desc"></p>
        </div>
      </div>
      <div class="spt-content pt-4 pb-0 mt-1 mb-0" v-if="(decryptedQuery.type!=0 && decryptedQuery.menh==1)">
        <div class="cheader1">
          {{ menhs.find(i => i.id == decryptedQuery.type).text }}
        </div>
        <div class="ccontent1">
          <p v-html="menhs.find(i=>i.id==decryptedQuery.type).desc"></p>
        </div>
      </div>
      <div class="spt-content" v-if="decryptedQuery.type==0">
        <div class="cheader mb-4">
          <img src="@/assets/images/simphongthuy/stick.png"/>
          <h2>Danh sách sim hợp ngày sinh {{ day }}/{{ month }}/{{ year }}</h2>
          <img src="@/assets/images/simphongthuy/stick.png"/>
        </div>
      </div>
      <div class="spt-content c2 pl-2 pr-2 pb-1 mt-4 pt-1 mb-4 pb-4">
        <div class="row">
          <div class="col-lg-4 col-12" v-for="(i,stt) in BoiSimBoloc" :key="stt">
            <div class="box1">
              <div class="box2 p-3">
                <div class="row">
                  <div class="col-12">
                    <h3 class="float-left">{{ f087(i.phone) }}</h3>
                    <h2 class="float-right">{{ i.money|number }}đ</h2>
                  </div>
                  <div class="col-12 pt-2">
                    <div class="b">Điểm phong thuỷ: <span
                        class="text-primary font-weight-bolder">{{ i.DiemPhongThuy }}/10</span></div>
                  </div>
                  <div class="col-12">
                    <div class="b">Sim ngũ hành: <span class="text-dark font-weight-bolder">{{ i.SimNguHanh }}</span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="b">Số nút: <span class="text-dark font-weight-bolder">{{ i.SoNut }}</span></div>
                  </div>
                  <div class="col-12">
                    <div class="b">Vận Cát - Hung: <span class="font-weight-bolder"
                                                         :class="i.VanCatHung=='CÁT' || i.VanCatHung=='ĐẠI CÁT'?'text-primary':'text-dark'">{{ i.VanCatHung }}</span>
                    </div>
                  </div>
                  <div class="col-12 pb-2">
                    <div class="b">Quẻ Kinh dịch: <span class="text-dark font-weight-bold">{{ i.QueKinhDich }}</span>
                    </div>
                  </div>

                </div>
                <div class="row footer">
                  <div class="col-6">
                    <b-button variant="outline-primary" @click="chonso(i.phone)" class="rounded-pill btn-block"
                              size="sm">Xem luận giải
                    </b-button>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-5">
                    <b-button @click="buy(i.phone)" variant="primary" class="rounded-pill btn-block" size="sm">MUA
                      NGAY
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-col cols="12" class="text-center">
            <b-pagination class="justify-content-center pt-1 pb-3"
                          v-model="page"
                          :total-rows="totalRows"
                          :per-page="pageSize"
                          first-number
                          last-number
                          @change="loadData()"
            ></b-pagination>
          </b-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Navigation, Pagination} from "swiper";
import {SwiperCore, Swiper, SwiperSlide} from "swiper-vue2";
import useJwt from "@/auth/jwt/useJwt";
import {
  BCol, BPagination, BFormInput, BFormGroup, BButton, BFormCheckbox, BFormRadio
} from "bootstrap-vue";
// Import Swiper styles
import "swiper/swiper-bundle.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Select2 from 'v-select2-component';
import CryptoJS from "crypto-js";
import {decrypt} from 'crypto';

SwiperCore.use([Navigation, Pagination]);

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    images["assets/images/ve-itel/" + item.replace("./", "")] = r(item);
  });
  return images;
}

const images = importAll(
    require.context("@/assets/images/ve-itel/", false, /.(png)$/)
);

export default {
  components: {
    Swiper,
    SwiperSlide,
    BFormInput,
    BFormGroup, BButton,
    BFormCheckbox,
    BFormRadio,
    Select2,
    "v-select": vSelect,
    BPagination,
    BCol
  },
  data() {
    return {
      iframeSrc: '',
      phone: '',
      year: 1986,
      month: 1,
      day: 1,
      hour: 'Tý - Từ 23 giờ đến 1 giờ sáng',
      gender: '1',
      sim_type: 0,
      menh: 0,
      c: {
        _track: "T_" + Math.random().toString(36).slice(2),
      },
      vw: window.innerWidth,
      sim_types: [
        {
          id: 1,
          text: 'Sim Gia đạo tình duyên',
          desc: 'Ngoài những SIM phong thủy mang ý nghĩa công danh sự nghiệp, phong thủy tài lộc nay đã có quẻ kinh dịch phong thủy kích tình duyên sinh vượng đón duyên mới, bồi đắp tình sâu nghĩa nặng ngăn chừng sự chia lìa, tan vỡ tình cảm đôi lứa.<br>Để tặng sự hưng vượng tình duyên, tình cảm thuận lợi thì SIM Gia đạo tình duyên sẽ là lựa chọn phù hợp nhất danh cho Quý khách'
        },
        {
          id: 2,
          text: 'Sim Đại cát',
          desc: 'Con người cũng như vạn vật tồn tại trên thế giới này đều được sinh khí cấu thành. Sinh khí không chỉ tồn tại trong lòng đất mà còn tồn tại thông qua nguồn năng lượng con số đồng hành với mỗi con người. Khi năng lượng sinh khí của con số sinh vượng ắt tạo được phúc lộc vĩnh trinh cho người may mắn sở hữu. Quý khách hãy lựa chọn cho mình SIM phong thủy thu hút may mắn và mang lại cát khí tốt lành'
        },
        {
          id: 3,
          text: 'Sim Công danh',
          desc: 'Sim phong thủy kích công danh sự nghiệp hội tụ năng lượng con số đầy đủ yếu tố VẬN - DANH - TÀI thâu tóm ý nghĩa hút tài vượng sinh quan, chức trọng quyền cao trên áp đảo vạn người. Từ đó có khả năng thay đổi hết thảy số mệnh tưởng chừng không thể xoay chuyển để đón công thành danh toại giống như “sông núi khó mà chuyển dời nhưng tương giao năng lượng Trời - Đất vẫn có thể di sông, đổi hướng”. Danh sách SIM phong thủy kích công danh, sự nghiệp'
        },
        {
          id: 4,
          text: 'Sim Tài lộc',
          desc: 'Tài là gốc, là nguồn nuôi sống vận mệnh con người. Tài vận tới yên dân lạc nghiệp, của cải dồi dào, tiền bạc đầy kho, phúc lộc lâu bền, cuộc đời hạnh phúc. Tài vận gặp bại vận tiền của đi dần, tai vạ bất ngờ, khuynh gia bại sản. Do đó, bất kể ai, cương vị nào không biết cầu thụ thông suốt, kích hoạt tài vận thì ấy là cuối đời cũng khó phát tài, hiển vinh.<br>Mỗi người sinh ra mỗi số mệnh, suy vượng khác nhau nhưng mười người thì chín người phú quý nhờ ấn thụ sinh của, hành đến vận quan. Nguyên lý này được quẻ dịch sim phong thủy phát triển, nguồn năng lượng cát của con số trong sim kích tài vận có khả năng bổ sung hành mệnh cân bằng, loại bỏ xung khắc, hút khí sinh tài cho người dùng.'
        },
      ],
      menhs: [
        {
          id: 1,
          text: 'Sim hợp mệnh Kim',
          desc: 'Vạn vật trên trái đất đều được phát sinh ra từ 5 yếu tố cơ bản Kim, Mộc, Thủy, Hỏa, Thổ trong môi trường tự nhiên và có mỗi quan hệ tồn tại song hành, tương tác qua lại và không thể tách rời.<br>Từ đó ngũ hành được ứng dụng vào những con số để tạo ra sim phong thủy, việc lựa chọn sim phong thủy hợp mệnh sẽ mang ý nghĩa bổ trợ, bù khuyết thiếu ngũ hành trong bát tự ngày sinh và mang lại trường khí tốt lành giúp mọi việc trở nên thuận lợi và hanh thông.'
        },
        {
          id: 2,
          text: 'Sim hợp mệnh Mộc',
          desc: 'Vạn vật trên trái đất đều được phát sinh ra từ 5 yếu tố cơ bản Kim, Mộc, Thủy, Hỏa, Thổ trong môi trường tự nhiên và có mỗi quan hệ tồn tại song hành, tương tác qua lại và không thể tách rời.<br>Từ đó ngũ hành được ứng dụng vào những con số để tạo ra sim phong thủy, việc lựa chọn sim phong thủy hợp mệnh sẽ mang ý nghĩa bổ trợ, bù khuyết thiếu ngũ hành trong bát tự ngày sinh và mang lại trường khí tốt lành giúp mọi việc trở nên thuận lợi và hanh thông.'
        },
        {
          id: 3,
          text: 'Sim hợp mệnh Thủy',
          desc: 'Vạn vật trên trái đất đều được phát sinh ra từ 5 yếu tố cơ bản Kim, Mộc, Thủy, Hỏa, Thổ trong môi trường tự nhiên và có mỗi quan hệ tồn tại song hành, tương tác qua lại và không thể tách rời.<br>Từ đó ngũ hành được ứng dụng vào những con số để tạo ra sim phong thủy, việc lựa chọn sim phong thủy hợp mệnh sẽ mang ý nghĩa bổ trợ, bù khuyết thiếu ngũ hành trong bát tự ngày sinh và mang lại trường khí tốt lành giúp mọi việc trở nên thuận lợi và hanh thông.'
        },
        {
          id: 4,
          text: 'Sim hợp mệnh Hỏa',
          desc: 'Vạn vật trên trái đất đều được phát sinh ra từ 5 yếu tố cơ bản Kim, Mộc, Thủy, Hỏa, Thổ trong môi trường tự nhiên và có mỗi quan hệ tồn tại song hành, tương tác qua lại và không thể tách rời.<br>Từ đó ngũ hành được ứng dụng vào những con số để tạo ra sim phong thủy, việc lựa chọn sim phong thủy hợp mệnh sẽ mang ý nghĩa bổ trợ, bù khuyết thiếu ngũ hành trong bát tự ngày sinh và mang lại trường khí tốt lành giúp mọi việc trở nên thuận lợi và hanh thông.'
        },
        {
          id: 5,
          text: 'Sim hợp mệnh Thổ',
          desc: 'Vạn vật trên trái đất đều được phát sinh ra từ 5 yếu tố cơ bản Kim, Mộc, Thủy, Hỏa, Thổ trong môi trường tự nhiên và có mỗi quan hệ tồn tại song hành, tương tác qua lại và không thể tách rời.<br>Từ đó ngũ hành được ứng dụng vào những con số để tạo ra sim phong thủy, việc lựa chọn sim phong thủy hợp mệnh sẽ mang ý nghĩa bổ trợ, bù khuyết thiếu ngũ hành trong bát tự ngày sinh và mang lại trường khí tốt lành giúp mọi việc trở nên thuận lợi và hanh thông.'
        }
      ],
      hours: ['Tý - Từ 23 giờ đến 1 giờ sáng', 'Sửu - Từ 1 giờ đến 3 giờ sáng', 'Dần - Từ 3 giờ đến 5 giờ sáng', 'Mão - Từ 5 giờ đến 7 giờ sáng', 'Thìn - Từ 7 giờ đến 9 giờ sáng', 'Tỵ - Từ 9 giờ đến 11 giờ sáng', 'Ngọ - Từ 11 giờ đến 13 giờ trưa', 'Mùi - Từ 13 giờ đến 15 giờ trưa', 'Thân - Từ 15 giờ đến 17 giờ chiều', 'Dậu - Từ 17 giờ đến 19 giờ tối', 'Tuất - Từ 19 giờ đến 21 giờ tối', 'Hợi - Từ 21 giờ đến 23 giờ tối',],
      page: 1,
      pageSize: 60,
      totalRows: 3000,
      decryptedQuery: {},
      key:"Everchosen",
    };
  },
  watch: {
    $route(to, from) {
      //this.$store.dispatch('simphongthuy/fetchBoiSimBoloc',this);
      this.DecryptQuery()
      this.loadData();
    },
  },
  computed: {
    BoiSimBoloc() {
      return this.$store.getters['simphongthuy/getBoiSimBoloc']
    },
  },
  created() {

  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    this.DecryptQuery()
    this.loadData();
    window.insider_object = window.insider_object || {};
    if (localStorage.trackId == undefined) {
      localStorage.trackId = Math.random().toString(36).slice(2);
    }
    if (this.$route.query && this.$route.query.cart_info){
      this.cart_info = JSON.parse(this.$route.query.cart_info);
    }
    this.tracking(localStorage.trackId, 1);
    window.insider_object.page = {
        type: "mua-sim-phong-thuy",
    };
    console.log("insider",window.insider_object)
  },
  methods: {
    DecryptQuery() {
      // console.log("queryURL", this.$route.query)
      const decryptedDob = CryptoJS.AES.decrypt(this.$route.query.day, this.key).toString(CryptoJS.enc.Utf8)
      const decryptedGender = CryptoJS.AES.decrypt(this.$route.query.gender,this.key).toString(CryptoJS.enc.Utf8)
      this.decryptedQuery = {
        gender: decryptedGender,
        dob: decryptedDob,
        type: this.$route.query.type,
        menh: this.$route.query.menh,
        hour: this.$route.query.hour,
      }
      // console.log("decrypted", this.decryptedQuery)
    },
    async buy(phone) {
      var x = await this.$store.dispatch('simphongthuy/fetchSPTSimDetail', {vm: this, phone: phone});
      console.log(x);
      //var cart_info = {"shipment_type":"home","_track":"T_" + Math.random().toString(36).slice(2),"isSimPhongThuy":1};
      //var tid = "T_" + Math.random().toString(36).slice(2);
      //var cart_info = {"shipment_type": "home", "_track": tid, "isSimPhongThuy": 1};
      //return;
      console.log("cart info",x)
      window.insider_object.page = {
        type: "AddToCart",
      };
      this.$router.push({
        path: '/mua-hang/buoc/2',
        query: {currentPhone: phone, cart: JSON.stringify(x), cart_info: JSON.stringify(this.cart_info)}
      });
    },
    tracking(id, step) {
      const parsedParams = this.decryptedQuery;
      this.$route.hash.split("&").map((part) => part.replace(/^#/, "")).forEach((param) => {
        const parts = param.split("=");
        parsedParams[parts[0]] = parts[1];
      });
      useJwt.post("tracking/" + id + "/" + step, {
        cart_info: this.cart_info,
        query: parsedParams,
      }).then((response) => {
        //console.log(response.data.result)
      });
    },
    loadData() {
      var x = this.decryptedQuery.dob.split("/");
      this.day = x[0];
      this.month = x[1];
      this.year = x[2];
      this.sim_type = this.decryptedQuery.type;
      this.menh = this.decryptedQuery.menh;
      this.hour = this.decryptedQuery.hour;
      this.gender = this.decryptedQuery.gender;
      this.$store.dispatch('simphongthuy/fetchBoiSimBoloc', this).then(resp => {
        this.$refs.sim_list.scrollIntoView({behavior: "smooth"})
        //  window.scrollBy(0, 20);
      });
      // console.log("day",this.day,"M",this.month,"Y",this.year)
    },
    chonso(phone) {
      this.$router.push({
        name: "diem-phong-thuy",
        query: {gender: this.gender, hour: this.hour, phone: phone, dob: this.day + "/" + this.month + "/" + this.year,cart_info: JSON.stringify(this.cart_info),}
      });
    },
    chonsim(type, menh) {
      this.loading(true);
      console.log("day",this.day + "/" + this.month + "/" + this.year)
      if (menh) {
        const encryptedGender =CryptoJS.AES.encrypt(this.gender,this.key).toString()
        const encryptedDob =  CryptoJS.AES.encrypt(this.day + "/" + this.month + "/" + this.year,this.key).toString()
        this.$router.push({
          name: "sim-phong-thuy-boloc",
          query: {
            gender: encryptedGender,
            hour: this.hour,
            menh: 1,
            type: type,
            day: encryptedDob,
            cart_info: JSON.stringify(this.cart_info),
          }
        });
      } else {
        const encryptedGender = CryptoJS.AES.encrypt(this.gender,this.key).toString()
        const encryptedDob =  CryptoJS.AES.encrypt(this.day + "/" + this.month + "/" + this.year,this.key).toString()
        this.$router.push({
          name: "sim-phong-thuy-boloc",
          query: {gender: encryptedGender, hour: this.hour, type: type, day: encryptedDob,cart_info: JSON.stringify(this.cart_info)}
        });
      }
      this.loading(false);
    },
    range(start, end) {
      var count = end - start;
      if (arguments.length == 1) {
        count = start;
        start = 0;
      }

      var foo = [];
      for (var i = 0; i < count; i++) {
        foo.push(start + i);
      }
      return foo;
    },
    f087(value) {
      return value.substr(0, 4) + " " + value.substr(4);
    },
    Img(pic) {
      return images[pic];
    },
    tracking1(id_, step) {
      var id = id_;
      if (!id_) {
        localStorage.trackId = Math.random().toString(36).slice(2);
        id = localStorage.trackId;
      }
      const parsedParams = this.decryptedQuery;
      this.$route.hash
          .split("&")
          .map((part) => part.replace(/^#/, ""))
          .forEach((param) => {
            const parts = param.split("=");
            parsedParams[parts[0]] = parts[1];
          });
      useJwt
          .post("tracking/" + id + "/" + step, {
            cart_info: this.cart_info,
            cart: this.cart,
            query: parsedParams,
          })
          .then((response) => {
            //console.log(response.data.result)
          });
    },
  },
};
</script>
<style lang="scss">
.spt .header {
  position: relative;
  z-index: 1;
  height: 590px;
  margin-top: 30px;
}

.spt .header1 {
  position: relative;
  z-index: 1;
  min-height: 390px;
  margin-top: 30px;
}

.spt .header .hcontent {
  padding: 41px;
  text-align: center;
  width: 100%;
}

.spt .header1 .hcontent {
  padding: 21px;
  text-align: center;
  width: 100%;
}

.spt .header .btntuoi, .spt .header1 .btntuoi {
  border-radius: 28.7953px !important;
  height: 60px;
  font-weight: 700;
  font-size: 16px;
  margin-top: 20px;
  width: 407px;
}

.spt .header .hcontent .form .text {
  line-height: 50px;
  font-weight: 700;
  font-size: 15px;;
}

.spt .header1 .hcontent .form .text-left {
  font-weight: 700;
  font-size: 15px;;
}

.spt .header1 .hcontent .form .text {
  text-align: left;
  line-height: 20px;
  font-weight: 700;
  font-size: 15px;;
}

.spt .header .hcontent .form h4, .spt .header1 .hcontent .form h4 {
  font-weight: 800;
  font-size: 19px;
  line-height: 35px;
  margin-top: 20px;
  border-top: 2px solid #ED1F24;
  margin-left: auto;
  margin-right: auto;
  width: 360px;
}

@media (min-width: 992px) {
  .spt .header .hcontent .form {
    width: 60%;
  }
  .spt .spt-header h2 {
    color: #424242;
    width: 50%;
    text-align: left;
  }
  .spt .header1 {
    display: none;
  }
  .spt .spt-header .card {
    display: none;
  }
}

@media (max-width: 992px) {
  .spt .spt-header .card img {
    width: 100% !important;
  }
  .spt .spt-header .card h4 {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #373737;
  }
  .spt .spt-header {
    margin-right: 15px;
    margin-left: 15px;
    width: auto !important;
  }
  .spt .spt-content {
    width: auto !important;
  }
  .spt .header.cat {
    display: none;
  }
  .spt .header .hcontent .form {
    width: 100%;
  }
  .spt .header .hcontent .form-control {
    margin-top: 10px;
  }
  .spt .spt-header h2 {
    color: #424242;
    width: 100%;
    text-align: center;
  }
  .spt .header .hcontent .form .text {
    line-height: 22px !important
  }
  .spt .header img, .spt .header .btntuoi {
    max-width: 100%;
  }
  .spt .header1 .btntuoi {
    max-width: 100% !important;
  }
  .spt .spt-content .cheader img {
    display: none !important
  }
  .spt .spt-content .cheader h2 {
    width: 100% !important;
  }
  .spt .spt-content.pt-4 {
    margin-right: 15px;
    margin-left: 15px;
  }
}

.spt .header .hcontent .form {
  max-width: 500;
  margin-left: auto;
  margin-right: auto;
}

.spt .header .hcontent h3, .spt .header1 .hcontent h3 {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #000000;
}

.spt .header .bg {
  background: url('~@/assets/images/simphongthuy/bgtop.png') no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #E5E5E5;
  opacity: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.15));
}

.spt {
  max-width: 122.4rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.spt .spt-content .loc {
  color: #fff;
  background: #ED1F24;
  border-radius: 34.809px;
  height: 45px;
  line-height: 45px;
  padding: 0 16px;
  font-weight: 600;
  font-size: 17.9242px;
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
}

.spt .spt-content .c1 h3 {
  font-weight: 800;
  font-size: 32px;
  line-height: 132.69%;
  //display: flex;
  align-items: center;
  color: #3E3E3E;
}

.spt .spt-content .c1 p {
  padding-top: 10px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  //display: flex;
  align-items: center;

  color: #000000;
}

.spt .spt-content .cheader {
  margin-top: 40px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  scroll-margin-top: -90px;
}

.spt .spt-content .cheader h2 {
  width: 40%;
  display: inline-block;
  color: #D20E27
}

.spt .spt-content .cheader img {
  width: 25%;
  display: inline-block;
  width: 161px;
}

.spt .spt-content h2 {
  font-weight: 700;
  font-size: 26px;
  line-height: 132.69%;
  align-items: center;
  text-align: center;
}

.spt .spt-header, .spt .spt-content {
  width: 100%;
}

.spt .spt-header h2 {
  font-weight: 700;
  font-size: 24px;
  line-height: 69px;
  color: #424242;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.spt .spt-content .cheader1 {
  height: 52px;
  border-radius: 8px 8px 0px 0px;
  background: url('~@/assets/images/simphongthuy/mask1.png') center no-repeat;
  background-size: cover;
  width: 100%;
  font-weight: 800;
  font-size: 25px;
  line-height: 52px;
  align-items: center;
  text-align: center;
  color: #FFE895;
  text-transform: uppercase;
}

.spt .header1 .bg {
  background: url('~@/assets/images/simphongthuy/bg6.png') no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #E5E5E5;
  opacity: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.15));
}

.spt .spt-content .ccontent1 {
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  border-left: 1px solid #D20E27;
  border-bottom: 1px solid #D20E27;
  border-right: 1px solid #D20E27;
  font-size: 18px;
  line-height: 1.5;
  padding: 30px;
}

.spt .spt-content.c2 {
  background: #f9f9f9;
  border: 1px solid #f3f3f3;
  border-radius: 8px;
}

.spt .spt-content.c2 .box1 {
  background: #FFFFFF;
  box-shadow: -2.44385px 0px 3.66577px rgba(0, 0, 0, 0.15);
  border-radius: 6.53271px;
  width: 100%;
}

.spt .spt-content.c2 .box2 {
  width: 100%;
  min-height: 300px;
  background: url('~@/assets/images/simphongthuy/mask2.png') bottom no-repeat;
  background-size: cover;
  margin: 10px 0;
}

.spt .spt-content.c2 .box2:hover {
  border: 1px solid #E9182C;
  border-radius: 6.53271px;
}

.spt .spt-content.c2 .box2 h3 {
  font-weight: 800;
  font-size: 19.5981px;
  line-height: 23px;
  color: #4D4D4D;
}

.spt .spt-content.c2 .box2 h2 {
  font-weight: 800;
  font-size: 25px;
  line-height: 23px;
  color: #FF0006;
}

.spt .spt-content.c2 .box2 .b::before {
  padding-right: 6px;
  content: url('data:image/svg+xml;base64,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')
}

.spt .spt-content.c2 .box2 .b {
  font-size: 13px;
  line-height: 20px;
}

.spt .spt-content.c2 .box2 .btn {
  padding: 0.5rem 1.3rem !important;
  height: 3.5rem;
  font-weight: 500;
  font-size: 13.4412px;
  border-radius: 50rem !important;
}

.spt .spt-content.c2 .box2 .footer {
  position: absolute;
  bottom: 3.5rem;
  width: calc(100% - 6rem);
}

.spt .vs__dropdown-toggle {
  border-radius: 1rem;
  height: 5rem !important;
}

.spt .vs__actions {
  padding: 4px 16px 0px 3px;
}

.spt .vs__selected-options {
  padding: 3px 3px 3px 3px;
}

.spt .vs__selected-options span {
  font-size: 2rem;
  font-weight: 500;
}

.vs__search, .vs__search:focus, .spt .phone {
  font-size: 2rem !important;
  font-weight: 500 !important;
}
</style>